import React, { useContext, useEffect, useState } from 'react';
import './Categories.css';
import { useNavigate, useParams } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import AppContext from './AppContext';
import { getCategories } from '../../service/menuOnlineService';
import LoadingSpinner from '../Shared/LoadingSpinner';
import Category from './Category';
import SearchComponent from './SearchComponent';
import SearchArchive from './SearchArchive';
// import { getPosition } from './util/ScrollRestoration';

const Categories = () => {

    const { name } = useParams();
    const [mode, setMode] = useState('Menu'); //Menu, Search
    const [items, setItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const appContext = useContext(AppContext)
    // const { pathname } = useLocation()
    let navigate = useNavigate();


    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllCategories = async () => {
            try {
                setIsLoading(true);

                let { status, data } = await getCategories(name, { cancelToken: cancelRequest.signal });
                if (status === 201) {
                    appContext.setLocationName(data.nickName)
                    appContext.setCurrencyType(data.currencyType)
                    appContext.setCompanyId(data.companyId)
                    setItems(data.items)
                    setIsLoading(false);
                }
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    navigate('/not-found')
                }
            }
        }
        fetchAllCategories();

        return () => {
            cancelRequest.cancel();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     if (items && pathname) {
    //         const elementParent = document.getElementById('scrollableDiv');
    //         getPosition(pathname, elementParent)

    //     }
    // }, [items, pathname]);
    const [searchText, setSearchText] = useState('')

    return (
        <React.Fragment>
            {
                <SearchComponent
                    searchTerm={searchText}
                    setSearchTerm={setSearchText}
                    isInputVisible={mode === 'Search' ? true : false}
                    setInputVisible={flag => flag ? setMode('Search') : setMode('Menu')}
                />
            }
            {
                mode === 'Menu' ?
                    <React.Fragment>
                        <div className="general-menu" id='scrollableDiv'>
                            <div id='child_scrollableDiv' className='m-0 p-0'></div>

                            {
                                !items || isLoading ?
                                    <div style={{ height: '70vh' }}>
                                        <LoadingSpinner />
                                    </div>
                                    :
                                    <React.Fragment>
                                        {
                                            !items.length ?
                                                <div className='Not-Exist'>
                                                    موردی برای مشاهده وجود ندارد
                                                </div>
                                                :
                                                <React.Fragment>
                                                    {
                                                        items.map((item, index) =>
                                                            <Category
                                                                key={item._id}
                                                                _id={item._id}
                                                                name={item.name}
                                                                image={item.image}
                                                                currencyType={appContext.currencyType}
                                                                companyId={appContext.companyId}
                                                            />
                                                        )
                                                    }
                                                </React.Fragment>
                                        }
                                    </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
                    :
                    <div>
                        <SearchArchive
                            searchInput={searchText}
                            companyId={appContext.companyId}
                            currencyType={appContext.currencyType}
                        />
                    </div>
            }
        </React.Fragment>
    );
}

export default Categories;